import type { StorageAdapter as AppLockStorageAdapter } from '@ascend/applock';
import type { PersistedState } from '@/types/persistence';
import { STORAGE_KEY } from '@/types/persistence';

let lockStore: AppLockStorageAdapter | null = null;

let enableSavesFn: (() => void) | null = null;
let disableSavesFn: (() => void) | null = null;
let rehydrateFn: ((store: AppLockStorageAdapter) => Promise<void>) | null = null;

export function setLockStore(store: AppLockStorageAdapter | null): void {
  lockStore = store;
}

export function getLockStore(): AppLockStorageAdapter | null {
  return lockStore;
}

export function registerPersistControls(
  enable: () => void,
  disable: () => void,
  rehydrate: (store: AppLockStorageAdapter) => Promise<void>,
): void {
  enableSavesFn = enable;
  disableSavesFn = disable;
  rehydrateFn = rehydrate;
}

export function enableSaves(): void {
  enableSavesFn?.();
}

export function disableSaves(): void {
  disableSavesFn?.();
}

export async function rehydrateFromLock(store: AppLockStorageAdapter): Promise<void> {
  await rehydrateFn?.(store);
}

export async function savePersistedState(state: PersistedState): Promise<void> {
  if (lockStore) {
    await lockStore.save(STORAGE_KEY, state);
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore quota errors
  }
}

export async function clearPersistedState(): Promise<void> {
  if (lockStore) {
    await lockStore.remove(STORAGE_KEY);
    return;
  }
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
